// extracted by mini-css-extract-plugin
export default {"rowDragActive":"SuperBatchModulesTableRow_rowDragActive__vcDL8","interview":"SuperBatchModulesTableRow_interview__cLXMm"};